// extracted by mini-css-extract-plugin
export default {"block":"block-dynamic__block___IY5hw"};